import { NgModule } from '@angular/core';
import { AuthBearerInterceptor } from './interceptors/auth-bearer.interceptor';

@NgModule({
    providers: [AuthBearerInterceptor],
})
export class AuthCoreModule {}
